import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiRequest from "../../api/request";

// Interval LMS (the live-video classroom app) integration, step 1: generate a class for the
// logged-in employee and get back a student link (public) + a host link (auto-signs the employee
// in as host, no separate LMS account). See node-portal-backend's src/routers/lms.route.js.
const initialState = {
    loading: false,
    lastLink: null,
    error: null,
};

export const generateClassLink = createAsyncThunk(
    "lms/generateClassLink",
    async ({ title, mode, reusable } = {}) => {
        const res = await apiRequest({
            method: "POST",
            url: "lms/create-class",
            data: { title, mode, reusable },
        });
        return res;
    }
);

// Step 2: random 1:1 matchmaking. joinRandomSession either matches immediately (someone else was
// already waiting) or queues the caller — in which case the match arrives later over the socket
// ('lms_random_matched' on the existing /chat namespace), not from this thunk's response.
export const joinRandomSession = createAsyncThunk(
    "lms/joinRandomSession",
    async () => {
        const res = await apiRequest({ method: "POST", url: "lms/random-session/join" });
        return res;
    }
);

export const cancelRandomSession = createAsyncThunk(
    "lms/cancelRandomSession",
    async () => {
        const res = await apiRequest({ method: "POST", url: "lms/random-session/cancel" });
        return res;
    }
);

const lmsSlice = createSlice({
    name: "lms",
    initialState,
    reducers: {
        clearLmsLink: (state) => {
            state.lastLink = null;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(generateClassLink.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(generateClassLink.fulfilled, (state, action) => {
                state.loading = false;
                if (action.payload?.status === "success") {
                    state.lastLink = action.payload;
                } else {
                    state.error = action.payload?.message || "Could not generate the class link";
                }
            })
            .addCase(generateClassLink.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error?.message || "Could not generate the class link";
            });
    },
});

export const { clearLmsLink } = lmsSlice.actions;
export default lmsSlice.reducer;
